import { useState, useContext, useEffect } from 'react';
// import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
// // import {  IconButton, CircularProgress } from '@shadcn-ui/react';
import { Button } from '../../components/ui/button'
import { Card } from '../../components/ui/card'
import { AuthContext } from '../../AuthProvider';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from "../../components/ui/accordion"
import Axios from '../../Axios';
import successicon from '../../asets/Group.svg'
import crossicon from '../../asets/x.svg'
import warningicon from '../../asets/alert-triangle.svg'
import fbicon from '../../asets/Vector.svg'
import Navbar2 from '../../navbar/Navbar2';
import { Trash2 } from 'lucide-react';
import settingicon from '../../asets/settings.svg'
import BottomNavbar from '../../components/bottomNavbar/BottomNavbar';
import { RefreshCw } from 'lucide-react';
import { EditIcon } from 'lucide-react';

// Modal imports
import { styled, css } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import Fade from '@mui/material/Fade';

// import ConnectToFacebook from './components/ConnectToFacebook';
// import Navbar2 from '../../navbar/Navbar2';
// import BottomNavbar from '../../components/bottomNavbar/BottomNavbar';
// import fbicon from '../../assets/account-details-icons/Vector.svg';

// import successicon from '../../assets/account-details-icons/Group.svg';
// import deleteicon from '../../assets/account-details-icons/trash-2.svg';
// import crossicon from '../../assets/account-details-icons/x.svg';
// import settingicon from '../../assets/account-details-icons/settings.svg';
import './accountdetails.css';
import ConnectToFacebook from './components/ConnectToFacebook';
import { ProfilePageContext } from '../../context/ProfilePageContext';
import ProfileCompleteCard from './components/ProfileCompleteCard';


function FacebookPages() {
    const { userToken } = useContext(AuthContext);
    const {getUserProfileData, userData, accountPercentage, fbpagePercentage, businessPercentage, notificationPercentage, overallPercentage } = useContext(ProfilePageContext)
    const [fetchFbPageLoad, setFetchFbPageLoad] = useState(false);
    const [clientPages, setClientPages] = useState([]);
    const [isPageLoad, setIsPageLoad] = useState(false);
    const [token, setToken] = useState("");
    const [deleteLoad, setDeleteLoad] = useState({});
    const [addPagesLoad, setAddPagesLoad] = useState(false);
    const [buttonStatus, setButtonStatus] = useState({});
    const [userName, setUserName] = useState("");
    const [loadRefreshPage, setLoadRefreshPage] = useState(false)
 
    // Edit modal state
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editPageData, setEditPageData] = useState({
        phone: "",
        about: "",
        pageId: "",
        name: ""
    });
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);

    const handelClientsPage = async (token) => {
        setFetchFbPageLoad(true);
        try {
            const res = await Axios.get(`/user-pages?access_token=${token}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: userToken,
                },
            });
            if (res.status === 200) {
                if (res?.data?.valid) {
                    getFacebookPagesFromDb();
                   
                } else {
                    setFetchFbPageLoad(false);
                }
            }
        } catch (error) {
            // setFetchFbPageLoad(false);
            // console.log("error")
        }finally{
            setFetchFbPageLoad(false);
        }
    };

    const getFacebookPagesFromDb = async () => {
        try {
            const res = await Axios.get("/user", {
                headers: {
                    Authorization: userToken,
                },
            });
            if (res.status === 200) {
                const data = res?.data?.user;
                if (data?.page_id?.length > 0) {
                    setUserName(res?.data?.user?.name);
                    setClientPages(data?.page_id);
                } else {
                    setClientPages([]);
                }
            }
        } catch (error) {
            // Handle error
        } finally {
            setFetchFbPageLoad(false);
        }
    };

    useEffect(() => {
        if (userToken) {
            getFacebookPagesFromDb();
        }
    }, [userToken]);


    const handlePageAccess = async (item) => {
        setAddPagesLoad(true);
        setButtonStatus({ ...buttonStatus, [item?.id]: 'loading' });
        setIsPageLoad(true);
        const body = { pageId: item?.id };
        try {
            const response = await Axios.post("/page-access-request", body, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: userToken,
                },
            });
            if (response.status === 200 && response.data.valid) {
                getFacebookPagesFromDb();
            }else{
                getFacebookPagesFromDb();
            }
        } catch (error) {
            console.log("error", error);
            getFacebookPagesFromDb();
        } finally {
            setAddPagesLoad(false);
            setButtonStatus({ ...buttonStatus, [item?.id]: 'notloading' });
            getUserProfileData(userToken)
        }
    };

    const handlePages = async (item) => {
        try {
            const res = await Axios.post("/add-pages", item, {
                headers: {
                    Authorization: userToken,
                },
            });
            if (res.status === 200) {
                getFacebookPagesFromDb();
            }
        } catch (error) {
            console.log("Error setting up request:");
        }
    };

    const handleDeletePage = async (pageid) => {
        setDeleteLoad({ ...deleteLoad, [pageid]: 'loading' });
        try {
            const res = await Axios.post("/delete-page", { pageId: pageid }, { headers: { Authorization: userToken } });
            if (res.status === 200 && res.data.valid) {
                getFacebookPagesFromDb();
            } else {
                console.log("error", res.data.message);
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setDeleteLoad({ ...deleteLoad, [pageid]: 'notloading' });
            getUserProfileData(userToken)
        }
    };

    const handleSubscribeApp = async (pageid) => {
        try {
            const res = await Axios.post("/subscribe-app", { pageId: pageid });
            if (res.status === 200 && res.data.valid) {
                getFacebookPagesFromDb();
            }
        } catch (error) {
            console.log("error", error);
        }
    };

    const onReferchPage = async (id)=>{
        setLoadRefreshPage(true)
        try {
            const res = await Axios.post("/refresh-page", { page_id: id }, { headers: { Authorization: userToken } });
            if (res.status === 200 && res.data.valid) {
                getFacebookPagesFromDb();
               
            } else {
                console.log("error", res.data.message);
                getFacebookPagesFromDb();
            }
        } catch (error) {
            console.log("error", error);
            getFacebookPagesFromDb();
        }finally{
            setLoadRefreshPage(false)
            getUserProfileData(userToken)
        }
    }

    // Edit page functions
    const handleEditPage = (pageData) => {
        setEditPageData({
            phone: pageData.phone ? pageData.phone.substring(3) : "",
            about: pageData.about || "",
            pageId: pageData.id,
            name: pageData.name
        });
        setEditModalOpen(true);
    };

    const handleCloseEditModal = () => {
        setEditModalOpen(false);
        setEditPageData({
            phone: "",
            about: "",
            pageId: "",
            name: ""
        });
    };

    const handleUpdatePage = async (e) => {
        e.preventDefault();
        
        if (!editPageData.phone) {
            return alert("Please Enter Number");
        }
        if (editPageData.phone.length !== 10) {
            return alert("Please Enter Valid Number");
        }

        try {
            setIsUpdateLoading(true);
            const res = await Axios.post("/update-page", {
                phone: `+91${editPageData.phone}`,
                about: editPageData.about,
                pageId: editPageData.pageId,
            }, {
                headers: {
                    Authorization: userToken
                }
            });

            if (res.status === 200) {
                alert("Page updated successfully");
                handleCloseEditModal();
                getFacebookPagesFromDb();
                getUserProfileData(userToken);
            }
        } catch (error) {
            console.log(error.message);
            alert("Failed to update page");
        } finally {
            setIsUpdateLoading(false);
        }
    };

    return (
        <>
        <div className="d-md-none">
     <Navbar2 menu={true} />
     </div>
            <div className=' max-w-[1350px] mx-auto bg-[#FBFBFB]'>
                <div class="flex items-start mb-5 mb-md-0 flex-col md:flex-row">
                    <div class=" w-full md:w-2/3 md:px-2">
                        <div className='py-2 px-2 flex justify-between items-center w-full]'>
                            <p className='m-0 p-0 text-[18px] md:text-[24px] text-black font-semibold leading-[22px] md:leading-[36px]'>Facebook Page</p>
                            <ConnectToFacebook handelClientsPage={handelClientsPage} setToken={setToken} fetchFbPageLoad={fetchFbPageLoad} />
                        </div>

                        <div className=' mt-3 px-1'>
                            <Accordion type="single" collapsible className="w-full ">

                                {clientPages.length > 0 && clientPages?.map((item, idx) => (

                                    <>
                                        {(item?.tasks?.includes("MANAGE") || !item?.hasOwnProperty('connected')) ? (<>

                                            <AccordionItem
                                                value={`item-${item?.id}`}
                                                className={`border-l-2 bg-white mb-2 mb-md-3 shadow-accordion rounded-sm py-2 px-2 shadow-sm item-center ${item?.connected === 'success'?((item?.leadgen_tos_accepted === false) || (!item?.lead_access)  || (item?.subscribed_apps?.data[0]?.id !== '1052762895750334') || (!item?.subscribed_apps?.data[0]?.subscribed_fields.includes("leadgen")))?'border-l-[#FF9EAF]':'':item?.connected === 'failed'?'border-l-[#FF9EAF]':''}  md:py-4 md:px-4`}
                                            >
                                                <AccordionTrigger className="no-underline hover:no-underline py-2 ">
                                                    <div className=' flex justify-between items-center w-[92%]'>
                                                        <div className='flex justify-start gap-2 flex-1 items-center'>
                                                           {(item?.connected === 'success' || !item?.hasOwnProperty('connected')) && <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={successicon} alt="" />} 
                                                            <p className='addpages-name p-0 m-0'>
                                                                {item?.name}
                                                            </p>
                                                            {buttonStatus[item?.id] === 'loading' && <div className=' flex items-center justify-center'><span class="loaderfbpage"></span></div> }
                                                        </div>

                                                      {item?.connected==='pending' && <Button  disabled={addPagesLoad ? true : false} onClick={(e) => {e.stopPropagation(); handlePageAccess(item); }} className="w-[77px] h-[30px] bg-[#ff7a00] hover:bg-[#ff7a00] text-white text-[12px]">{buttonStatus[item?.id] === 'loading'?'Connect...':'Connect'}</Button>}  
                                                      {(item?.connected === 'success' || item?.connected === 'failed') && <>
                                                        {((item?.leadgen_tos_accepted===false) || (!item?.lead_access) || (item?.subscribed_apps?.data[0]?.id !== '1052762895750334') || (!item?.subscribed_apps?.data[0]?.subscribed_fields.includes("leadgen")) )?<div className='flex gap-1 justify-end items-center'>
                                                            <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={warningicon} alt="" />
                                                            <p className='p-0 m-0 addpages-p'>Action required</p>
                                                        </div> :null}
                                                      
                                                      </>}
                                                      
                                                    </div>

                                                </AccordionTrigger>
                                                <AccordionContent>
                                                             <div>
  
                                                           <div className="mb-3"> {item?.connected === 'failed' ? <p className='addpages-p p-0 m-0'><img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={warningicon} alt="" />  {item?.user_name?item?.user_name:userName} may not be admin business account that owns this page</p> : null}</div>
                                                            {(item?.connected === 'success' || item?.connected === 'failed') && <div>
                                                                {item?.connected === 'success'?(<>
                                                                    {item?.leadgen_tos_accepted === false &&  <div className="mb-3 flex justify-start items-center gap-1">
                                                                   <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={crossicon} alt="" />
                                                                   {item?.leadgen_tos_accepted === false && <p className='addpages-p p-0 m-0'>  TOS Not Accepted, <a href="https://www.facebook.com/ads/leadgen/tos" target='_blank' style={{ color: 'black' }}><b>click here</b></a> to accept</p>}

                                                                   </div>}
                                                                </>):""}
                                                                  
                                                                
                                                                  {item?.connected === 'success'? (<>
                                                                    {((item?.subscribed_apps?.data[0]?.id !== '1052762895750334') || (!item?.subscribed_apps?.data[0]?.subscribed_fields.includes("leadgen"))) && <div className="mb-3 flex justify-start items-center gap-1">
                                                                   <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={crossicon} alt="" />
                                                                   {((item?.subscribed_apps?.data[0]?.id !== '1052762895750334') || (!item?.subscribed_apps?.data[0]?.subscribed_fields.includes("leadgen"))) && <p className='addpages-p p-0 m-0'>  App Subscription, <span onClick={() => handleSubscribeApp(item?.id)} style={{ color: 'black', cursor: 'pointer' }}><b>click here</b></span> to retry</p>}

                                                                   </div>}
                                                                  </>):""}
                                                                  
                                                                   {item?.connected === 'success'?(<>
                                                                   
                                                                    {!item?.lead_access &&  <div className="mb-3 flex justify-start items-center gap-1">
                                                                   <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={crossicon} alt="" />
                                                                   {!item?.lead_access && <p className='addpages-p p-0 m-0'>  Lead Access, contact LeapX support</p>}

                                                                   </div>} 
                                                                   
                                                                   </>):""}
                                                                  
                                                                
                                                            </div>}

                                                          <div className=' flex justify-between items-center'>
                                                          <div className=' flex justify-start gap-1 items-center'>
                                                         <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={fbicon} alt="" />
                                                         <p className='p-0 m-0 addpages-p' addpages-p>{(item?.tasks?.includes("MANAGE") || !item?.hasOwnProperty('connected')) ? `${item?.user_name?item?.user_name:userName} has full access to this page` : `${item?.user_name?item?.user_name:userName} has partial access to this page`}</p>
                                                        
                                                         </div>
                                                         <div>


                                                       {item?.connected === 'success'?((item?.subscribed_apps?.data[0]?.id !== '1052762895750334') || (!item?.subscribed_apps?.data[0]?.subscribed_fields?.includes("leadgen")) || (!item?.lead_access) || item?.leadgen_tos_accepted === false )?(<>
                                                        <button onClick={()=>onReferchPage(item?.id)} disabled={loadRefreshPage?true:false} className='me-3'><RefreshCw className={`text-black w-[18px] h-[18px] ${loadRefreshPage?'refreshpage':''}`} /></button>
                                                       
                                                       </>):'':''} 
                                                        
                                                         <button onClick={() => handleEditPage(item)} className='me-3'><EditIcon className='text-blue-500 w-[18px] h-[18px]' /></button>
                                                         <button onClick={() => handleDeletePage(item?.id)} disabled={deleteLoad[item?.id] === 'loading' ? true : false}><Trash2  style={{ opacity: deleteLoad[item?.id] === 'loading' ? '0.7' : '1' }} className='text-red-500 w-[18px] h-[18px] m-0 ' /></button>
                                                        
                                                          </div>
                                                          </div>


                                                        </div>
                                                </AccordionContent>
                                            </AccordionItem>

                                        </>) : (<>

                                            {/* action required */}
                                            <AccordionItem
                                                value={`item-${item?.id}`}
                                                className={  `border-l-2 bg-white  mb-2 mb-md-3  rounded-sm py-2 px-2 shadow-accordion item-center  border-l-[#FF9EAF] md:py-4 md:px-4`}
                                            >
                                                <AccordionTrigger className="no-underline hover:no-underline py-2">
                                                    <div className=' flex justify-between items-center w-[92%]'>
                                                        <div className='flex justify-start gap-1 items-center '>
                                                            {/* <img src={successicon} alt="" /> */}
                                                            <p className='p-0 m-0 addpages-name'>
                                                                {item?.name}
                                                            </p>
                                                        </div>
                                                        <div className='flex gap-1 justify-start items-center'>
                                                            <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' src={warningicon} alt="" />
                                                            <p className='p-0 m-0 addpages-p'>Action required</p>
                                                        </div>

                                                        {/* <Button className="w-[80px] h-[30px] bg-[#62c] text-white text-[12px]">Connect</Button> */}
                                                    </div>

                                                </AccordionTrigger>
                                                <AccordionContent>
                                                    <div className='mb-3 mt-3 gap-1 flex items-center justify-start'>
                                                        <img src={warningicon} className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px] ' alt="" />
                                                        <p className='p-0 m-0 addpages-p'> {item?.user_name?item?.user_name:userName} doesn't have admin access to link this page to LeapX</p>
                                                    </div>
                                                    <div className=" mb-3 flex items-center justify-start gap-1">
                                                        <img className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px] '  src={settingicon} alt="" />
                                                        <p className='p-0 m-0 addpages-p'> Add pages using the admin account <a href="+" target='_blank' style={{ color: '#ff7a00' }}>(refer this link)</a></p>
                                                    </div>
                                                    {/* delete button container */}
                                                      <div className=' flex justify-between items-center'>
                                                      <div className='flex justify-start items-center gap-1'>
                                                            <img src={fbicon} alt="" className=' w-[14px] h-[14px] md:w-[19px] md:h-[19px]' />
                                                            <p className='p-0 m-0 addpages-p' >{item?.user_name?item?.user_name:userName} has partial access to this page</p>

                                                        </div>

                                                        <div>
                                                            <button onClick={() => handleEditPage(item)} className='me-3'><EditIcon className='text-blue-500 w-[18px] h-[18px]' /></button>
                                                          <button disabled={deleteLoad[item?.id] === 'loading' ? true : false} onClick={() => handleDeletePage(item?.id)}><Trash2  style={{ opacity: deleteLoad[item?.id] === 'loading' ? '0.7' : '1' }} className='text-red-500 w-[18px] h-[18px]' /></button>
                                                        
                                                        </div>
                                                      </div>
                                                   
                                                </AccordionContent>
                                            </AccordionItem>
                                        </>)}


                                    </>
                                ))}



                            </Accordion>
                        </div>
                    </div>
                    <div className="md:w-1/3">
                        {/* Column 2 (4/12 or 1/3) - Integration Steps and Profile Complete Card commented out */}
                    </div>
                </div>
            </div>
            <div className="d-block d-md-none"><BottomNavbar /></div>

            {/* Edit Page Modal */}
            <EditPageModal
                open={editModalOpen}
                onClose={handleCloseEditModal}
                pageData={editPageData}
                setPageData={setEditPageData}
                onUpdate={handleUpdatePage}
                isLoading={isUpdateLoading}
            />
        </>
    );
}

// Edit Page Modal Component
function EditPageModal({ open, onClose, pageData, setPageData, onUpdate, isLoading }) {
    return (
        <Modal
            aria-labelledby="edit-modal-title"
            aria-describedby="edit-modal-description"
            open={open}
            onClose={onClose}
            closeAfterTransition
            slots={{ backdrop: StyledBackdrop }}
        >
            <Fade in={open}>
                <ModalContent sx={modalStyle}>
                    <div>
                        <h5 className='text-center mb-3' style={{ textTransform: 'uppercase' }}>
                            Edit Page Details
                        </h5>
                        <form onSubmit={onUpdate}>
                            {/* Account Name (Read-only) */}
                            <div className="mb-3">
                                <label htmlFor="accountName" className="form-label">Account Name</label>
                                <input 
                                    type="text" 
                                    value={pageData.name} 
                                    className='form-control' 
                                    disabled
                                    style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
                                />
                                <small className="text-muted">Account name cannot be edited</small>
                            </div>

                            {/* Phone Number */}
                            <div className="mb-3">
                                <label htmlFor="phone" className="form-label">Phone</label>
                                <input 
                                    type="text" 
                                    value={pageData.phone} 
                                    placeholder='Phone number' 
                                    onChange={(e) => setPageData({...pageData, phone: e.target.value})}  
                                    className='form-control' 
                                    maxLength="10"
                                />
                            </div>

                            {/* About */}
                            <div className="mb-3">
                                <label htmlFor="about" className="form-label">About</label>
                                <textarea 
                                    value={pageData.about} 
                                    placeholder='About your page' 
                                    onChange={(e) => setPageData({...pageData, about: e.target.value})} 
                                    className='form-control' 
                                    style={{width:'100%'}} 
                                    cols="12" 
                                    rows="4"
                                />
                            </div>

                            <div className='d-flex gap-2 justify-content-end'>
                                <Button 
                                    type="button"
                                    variant="outlined" 
                                    onClick={onClose}
                                    disabled={isLoading}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    type="submit"
                                    sx={{backgroundColor:'#62c', color:'white'}} 
                                    disabled={isLoading} 
                                    variant='contained'
                                >
                                    {isLoading ? 'Updating...' : 'Update'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </ModalContent>
            </Fade>
        </Modal>
    );
}

// Styled Components for Modal
const Backdrop = ({ open, ...other }) => (
    <Fade in={open}>
        <div {...other} />
    </Fade>
);

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const Modal = styled(BaseModal)`
    position: fixed;
    z-index: 1300;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
    z-index: -1;
    position: fixed;
    inset: 0;
    background-color: rgb(0 0 0 / 0.5);
    -webkit-tap-highlight-color: transparent;
`;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    '@media (min-width: 960px)': {
        width: 450,
    },
};

const ModalContent = styled('div')(
    ({ theme }) => css`
        font-family: 'IBM Plex Sans', sans-serif;
        font-weight: 500;
        text-align: start;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow: hidden;
        background-color: ${theme?.palette?.mode === 'dark' ? grey[900] : '#fff'};
        border-radius: 8px;
        border: 1px solid ${theme?.palette?.mode === 'dark' ? grey[700] : grey[200]};
        box-shadow: 0 4px 12px
            ${theme?.palette?.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(0 0 0 / 0.2)'};
        padding: 24px;
        color: ${theme?.palette?.mode === 'dark' ? grey[50] : grey[900]};
    `,
);

export default FacebookPages;
